"use strict";

// Copyright 2012-2020 The MathWorks, Inc.
define(['dojo/_base/declare', 'dojo/_base/Deferred', 'dojo/_base/lang', 'mw-remote/RemoteEndPointsManager', 'mw-utils/Utils'], function (declare, Deferred, lang, RemoteEndPointsManager, Utils) {
  /**
   * Internal private class used by the RequestManager, ResponseManager, and FaultManager.
   */
  return declare([], {
    constructor: function constructor(args) {
      args = args || {};
      this.requestMessages = args.requestMessages || {};
      this.responseMessages = args.responseMessages || {};
      this.context = args.context;
      this.computeToken = args.computeToken;
      this.uuidClassifierMap = args.uuidClassifierMap || {};
      this.endPointName = args.endPointName || null;
      this.allowedMessages = args.allowedMessages || [];
      this.ignoreMessageTypes = args.ignoreMessageTypes || [];
      this.sendMessage = args.sendMessage;
    },

    /**
     * Add a request message to the transaction.
     * @param type Type of message.
     * @param value A message object or array of message objects.
     * @param classifier An optional string to classifier this particular message.
     */
    addRequestMessage: function addRequestMessage(type, value, classifier) {
      if (!value) {
        return;
      }

      var isMessageContainerBased = RemoteEndPointsManager.isEndpointMessageContainerBased(this.endPointName);

      if (!this.requestMessages[type]) {
        this.requestMessages[type] = [];
      }

      if (lang.isArray(value)) {
        value.forEach(function (val) {
          this.addRequestMessage(type, val, classifier);
        }, this);
      } else {
        if (!isMessageContainerBased) {
          this.requestMessages[type] = value;
        } else {
          value.uuid = value.uuid || this._generateUuid();

          if (classifier) {
            this.uuidClassifierMap[value.uuid] = classifier;
          }

          this.requestMessages[type].push(value);
        }
      }

      this.requestMessages = this._filterMessages(this.requestMessages);
    },

    /**
     * Filter out disallowed messages. This is useful for input mode, and while unauthorized.
     * @param originalMessages
     * @return Filtered messages
     */
    _filterMessages: function _filterMessages(originalMessages) {
      var filteredMessages = {};
      this.getRequestMessageTypes().forEach(function (type) {
        if (this.allowedMessages.length === 0 || this.allowedMessages.indexOf(type) >= 0) {
          filteredMessages[type] = originalMessages[type];
        }
      }, this);
      return filteredMessages;
    },

    /**
     * Get an array of response message types in this transaction. This is useful for iteration
     * through responses.
     */
    getResponseMessageTypes: function getResponseMessageTypes() {
      var type;
      var types = [];

      for (type in this.responseMessages) {
        if (this.responseMessages.hasOwnProperty(type)) {
          types.push(type);
        }
      }

      return types;
    },

    /**
     * Get an array of request message type
     */
    getRequestMessageTypes: function getRequestMessageTypes() {
      var type;
      var types = [];

      for (type in this.requestMessages) {
        if (this.requestMessages.hasOwnProperty(type)) {
          types.push(type);
        }
      }

      return types;
    },

    /**
     * Get the message classifier for a particular message (request or response).
     * @param message Message from this transaction.
     */
    getMessageClassifier: function getMessageClassifier(message) {
      if (message && message.uuid && this.uuidClassifierMap.hasOwnProperty(message.uuid)) {
        return this.uuidClassifierMap[message.uuid];
      } else {
        return '';
      }
    },

    /**
     * Private function to send a transaction. It handles converting the data into the type
     * required by the transport (String). It also sets the Deferred into the transaction.
     */
    send: function send() {
      this._removeEmptyMessages();

      if (!this._isEmpty(this.requestMessages)) {
        this.startTime = new Date().getTime();
        this.deferred = this._doSend(this._getRequest(this.requestMessages));
        this.deferred.addCallback(this, this._processResponse);
        this.deferred.addErrback(this, this._processFault);
      } else {
        this.deferred = new Deferred();
        this.deferred.callback();
      }
    },
    addIgnoreMessageType: function addIgnoreMessageType(type, classifier) {
      if (this.getRequestMessageTypes().indexOf(type) > -1) {
        if (classifier) {
          var uuid;

          for (uuid in this.uuidClassifierMap) {
            if (this.uuidClassifierMap.hasOwnProperty(uuid) && classifier && this.uuidClassifierMap[uuid] === classifier) {
              this.ignoreMessageTypes.push(type + ':' + classifier);
            }
          }
        } else {
          this.ignoreMessageTypes.push(type);
        }
      }
    },
    // todo: Move this check to an early stage
    _removeEmptyMessages: function _removeEmptyMessages() {
      if (!this._isEmpty(this.requestMessages)) {
        var messageType;

        for (messageType in this.requestMessages) {
          if (this.requestMessages.hasOwnProperty(messageType)) {
            if (lang.isArray(this.requestMessages[messageType]) && Utils.getArrayLength(this.requestMessages[messageType]) === 0) {
              delete this.requestMessages[messageType];
            }
          }
        }
      }
    },

    /**
     * Utility function to determine if an object is empty (has no enumerable properties)
     */
    _isEmpty: function _isEmpty(obj) {
      var prop;

      for (prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }

      return true;
    },
    _generateUuid: function _generateUuid() {
      return Utils.generateUuid();
    }
  });
});
//# sourceMappingURL=Transaction.js.map
